<template>
    <Modal id="upgrade-needed" :show-footer="false" :show-title="false" @cancel="cancel">
        <div class="upgrade-needed-container">
            <div class="upgrade-plan-container">
                <UpgradeSVG class="upgrade-svg" :class="{ upgrading: startAnimation }" />
                <UpgradeSVG class="upgrade-svg" :class="{ upgrading: startAnimation }" />
                <UpgradeSVG class="upgrade-svg" :class="{ upgrading: startAnimation }" />
                <Card
                    class="plan"
                    :plan="nextPlan"
                    :period="period"
                    :details="details"
                    :plans="plans"
                    :current-plans="[nextPlan]"
                    :is-selected="true"
                    :is-readonly="true"
                    :show-details="true"
                />
            </div>
        </div>
        <div class="upgrade-needed-footer">
            <SupsisButton ghost @click="cancel">İptal Et</SupsisButton>
            <SupsisButton primary @click="upgrade">Onayla</SupsisButton>
        </div>
    </Modal>
</template>
<script>
import Modal from "../common/Modal2.vue";
import { mapActions, mapState } from "vuex";
import Card from "./Card.vue";
import UpgradeSVG from "./svg/UpgradeSVG.vue";
import SupsisButton from "../../views/Pages/Settings/components/SupsisButton.vue";

export default {
    name: "PlanUpgradeConfirm",
    components: { SupsisButton, UpgradeSVG, Card, Modal },
    props: {
        type: {
            type: String,
            default: null,
        },
    },
    computed: {
        ...mapState({
            plans: (state) =>
                state.site.plans
                    .filter((plan) => plan.type !== "feature")
                    .filter((plan) => plan.type !== "extra-package")
                    .filter((plan) => !plan.isDeleted),
            currentPlans: (state) => state.site.currentPlans,
            users: (state) => state.user.users,
            activeUserCount: (state) => state.user.activeUserCount,
            whatsappChannels: (state) =>
                state.channel.channels.filter((x) => ["whatsapp-v2", "whatsapp-v1", "whatsapp-qr"].includes(x.type))
                    .length,
            whatsappBusinessChannels: (state) =>
                state.channel.channels.filter((channel) => channel.type === "whatsapp-business-api").length,
        }),
    },
    data: () => ({
        nextPlan: null,
        period: "monthly",
        details: {},
        startAnimation: false,
    }),
    mounted() {
        this.init();
    },
    methods: {
        ...mapActions({
            subscribePlan: "site/subscribePlan",
        }),
        init() {
            const grouped = this.$_.groupBy(this.currentPlans, (currentPlan) => currentPlan.planType);
            const sortedPlan = this.plans
                .filter((plan) => plan.type === this.type && !plan.isFreePlan)
                .sort((a, b) => a.order - b.order);
            const plansMap = this.plans.reduce((acc, plan) => {
                acc[plan._id] = plan;
                return acc;
            }, {});
            const currentPlans = grouped[this.type] || [];
            const currentPlanAction = currentPlans[0];
            const currentPlan = plansMap[currentPlanAction?.planId];
            const currentPlanIndex = sortedPlan.findIndex((plan) => plan._id === currentPlan?._id);
            this.nextPlan = currentPlan?.isFreePlan ? sortedPlan[currentPlanIndex + 1] : currentPlan || sortedPlan[0];
            this.period = currentPlanAction?.period || "monthly";
            if (this.type === "supsis") {
                const activeUserCount = this.activeUserCount;
                this.details = {
                    agentCount: activeUserCount + 1,
                };
            } else if (this.type === "whatsapp") {
                const channelCount = this.whatsappChannels;
                this.details = {
                    whatsappChannel: channelCount + 1,
                };
            } else if (this.type === "whatsapp-business") {
                const channelCount = this.whatsappBusinessChannels;
                this.details = {
                    whatsappChannel: channelCount + 1,
                };
            }
        },
        upgrade() {
            this.startAnimation = true;
            setTimeout(() => {
                this.subscribe();
            }, 900);
        },
        subscribe() {
            this.subscribePlan({
                siteId: this.siteId,
                planId: this.nextPlan._id,
                period: this.period,
                details: this.details,
            }).then((action) => {
                if (!action || !action.planType) {
                    this.$toasted.error(
                        !this.billingDetail || !this.billingDetail.binNumber
                            ? "Lütfen Kredi Kartınızı Giriniz."
                            : "Geçersiz kredi kartı, Ödeme Alınamadı.",
                        {
                            duration: 3000,
                            position: "top-center",
                        }
                    );
                } else {
                    this.$notification.success({
                        message: "Abonelik Başlatıldı",
                        description: "Aboneliğiniz başarılı bir şekilde başlamıştır.",
                    });
                }
                this.$emit("close");
            });
        },
        cancel() {
            this.$emit("close");
        },
    },
};
</script>
<style lang="scss">
@keyframes tilt-shaking {
    0% {
        transform: translate(0px);
    }
    100% {
        transform: translate(0px, -500px);
    }
}

#upgrade-needed {
    .upgrade-needed-container {
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;

        .upgrade-plan-container {
            position: relative;

            .upgrade-svg {
                position: absolute;
                z-index: 1;

                &.upgrading {
                    transform: translate(0px, -500px);
                    animation: tilt-shaking 1s ease;
                }

                &:nth-child(1) {
                    top: 164px;
                    left: -37px;
                }

                &:nth-child(2) {
                    top: 70px;
                    right: -37px;
                }

                &:nth-child(3) {
                    top: 320px;
                    right: -37px;
                }
            }
        }
    }

    .upgrade-needed-footer {
        margin-top: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
    }
}
</style>
